import { Button, Modal } from '@design-systems/canvas-ui'
import Icon, {
  CheckmarkIcon,
  PaperPlaneIcon,
} from '@design-systems/react-icons'

// Last stop before an admin takes over.
const PublishQueueModal = ({
  approvedCount = 0,
  isOpen,
  isSending = false,
  onClose,
  onConfirm,
}) => {
  const footer = (
    <div className="publish-queue-modal__actions">
      <Button onClick={onClose} variant="secondary">
        Cancel
      </Button>
      <Button isLoading={isSending} onClick={onConfirm} variant="primary">
        <span className="upload-documents__button-content">
          <Icon size="sm" svg={CheckmarkIcon} /> Confirm &amp; send
        </span>
      </Button>
    </div>
  )

  return (
    <Modal
      className="publish-queue-modal"
      footer={footer}
      headingText="Send to Publish Queue"
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
    >
      <span className="publish-queue-modal__badge">
        <Icon size="lg" svg={PaperPlaneIcon} />
      </span>
      <p>
        {approvedCount} approved sections will be sent for Admin review. They go
        live once an admin publishes to connected systems.
      </p>
      <dl className="publish-queue-modal__summary">
        <div>
          <dt>Approved</dt>
          <dd className="publish-queue-modal__count--approved">
            {approvedCount} sections
          </dd>
        </div>
      </dl>
    </Modal>
  )
}

export default PublishQueueModal
